import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
//import { fitBounds } from 'google-map-react/utils';
import Results from './bper-results';
import useSupercluster from 'use-supercluster';
import Button from './bper-button';


const Marker = ({ children }) => children;
const MAP_OFFSET = window.innerWidth > 767 ? 200 : 0; //devo spostare la mappa più a sinistra perchè sono presenti i risultati di ricerca

const PADDINGS = {
    top: 0,
    right: 0,
    bottom: 0,
    left: MAP_OFFSET
};

function MapWrapper({
    showResults,
    locations,
    mapPosition,
    markerPosition,
    apiKey,
    onApiLoaded,
    changeMapCenter,
    zoom,
    setZoom,
    place,
    activeMarker,
    updatedSelected,
    configurations,

    hideDotti,
    translations,
    searchHere,
    showServiceInfo,
    setShowServiceInfo,
    setShowButtonRepeatSearch,
    isDefaultValues
}) {
    const googleMapRef = useRef(null);
    const mapRef = useRef();
    const [bounds, setBounds] = useState(null);
    const [mapCenter, setMapCenter] = useState(mapPosition);
    let newMapPosition = mapPosition;

    useEffect(() => {
        setMapCenter(mapPosition);
    }, [mapPosition]);

    //DEVO spostare la mappa perchè ci sono i risultati delle filiali in mezzo.
    /*const bounds2 = mapRef && mapRef.current && mapRef.current.getBounds();
    if (bounds2 && !isDefaultValues) { //se ho la mappa con valori di default NON sposto
        const NE = bounds2.getNorthEast();
        const SW = bounds2.getSouthWest();
        const latOffset = (MAP_OFFSET * (NE.lng() - SW.lng())) / window.innerWidth;
        newMapPosition = {
            lat: mapCenter.lat,
            lng: mapCenter.lng - latOffset
        };
    }*/

    const handleHideDotti = () => {
        hideDotti();
    }

    const handleSelected = (obj) => {
        const mapPos = { lat: obj.lat, lng: obj.lng };
        updatedSelected(obj);
        changeMapCenter(mapPos);
        setMapCenter(mapPos);
    };

    const handleApiLoaded = (map, maps) => {
        mapRef.current = map;

        onApiLoaded({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
            mapRef: mapRef
        });
    };

    const handleChangeMapPosition = () => {
        const mapCenter = mapRef && mapRef.current && mapRef.current.getCenter();
        if (mapCenter) {
            const center = {
                lat: mapCenter.lat(),
                lng: mapCenter.lng()
            }
            /*
                //spostamento mappa.non lo utilizziamo più
                        const bounds2 = mapRef && mapRef.current && mapRef.current.getBounds();
                        let newMapPosition = mapCenter;
                        if (bounds2) {
                            const NE = bounds2.getNorthEast();
                            const SW = bounds2.getSouthWest();
                            const latOffset =
                                (MAP_OFFSET * (NE.lng() - SW.lng())) / window.innerWidth;
                            newMapPosition = {
                                lat: mapCenter.lat,
                                lng: mapCenter.lng - latOffset
                            };
                        }
            
                        setMapCenter(newMapPosition);*/
            if (Math.abs(center.lng - newMapPosition.lng) > 0.00000001) {
                setShowButtonRepeatSearch(true);
            }
        }
    }

    const points = !locations
        ? []
        : locations.map((item) => ({
            type: 'Feature',
            properties: {
                cluster: false,
                itemId: item.id,
                category: item.category,
                bankCode: item.bankCode,
                subsdiaryType: item.subsdiaryType
            },
            geometry: {
                type: 'Point',
                coordinates: [
                    parseFloat(item.longitude),
                    parseFloat(item.latitude)
                ]
            }
        }));

    const { clusters, supercluster } = useSupercluster({
        points,
        bounds,
        zoom,
        options: { radius: 150, maxZoom: 20, log: false } //75 radius
    });

    const showShadow = parseInt(localStorage.getItem("dottiCount")) === 1;


    return (
        <>
            {newMapPosition ? (
                <>
                    <div className="google-map" ref={googleMapRef}>
                        {locations &&
                            (showResults ||
                                (activeMarker && activeMarker.id)) && (
                                <div className="results-wrapper">
                                    <div style={{ position: 'relative' }}>
                                        <Results
                                            locations={locations}
                                            idSelected={
                                                activeMarker &&
                                                activeMarker.id
                                            }
                                            setSelected={handleSelected}
                                            place={place}
                                            apiKey={apiKey}
                                            translations={translations}
                                            configurations={configurations}
                                            showServiceInfo={showServiceInfo}
                                            setShowServiceInfo={setShowServiceInfo}
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="google-map-content" style={{ width: "100%" }}>
                            <GoogleMapReact
                                bootstrapURLKeys={{
                                    key: apiKey,
                                    libraries: ['places', 'geometry']
                                }}
                                style={{ width: "100%", height: "100%" }}
                                key="map-react"
                                //defaultCenter={newMapPosition}
                                center={newMapPosition}
                                zoom={zoom}
                                //defaultZoom={zoom}
                                yesIWantToUseGoogleMapApiInternals={true}
                                onGoogleApiLoaded={({ map, maps }) => {
                                    handleApiLoaded(map, maps);
                                }}
                                onChange={({ zoom, bounds }) => {
                                    setZoom(zoom);
                                    handleChangeMapPosition();
                                    setBounds([
                                        bounds.nw.lng,
                                        bounds.se.lat,
                                        bounds.se.lng,
                                        bounds.nw.lat
                                    ]);
                                }}
                            >
                                {clusters &&
                                    clusters.map((cluster) => {
                                        const [
                                            longitude,
                                            latitude
                                        ] = cluster.geometry.coordinates;
                                        const {
                                            cluster: isCluster,
                                            point_count: pointCount
                                        } = cluster.properties;

                                        if (isCluster) {
                                            return (
                                                <Marker
                                                    key={`cluster-${cluster.id}`}
                                                    lat={latitude}
                                                    lng={longitude}
                                                >
                                                    <div
                                                        className="cluster-marker"
                                                        style={{
                                                            //width: `${10 + (pointCount / points.length) * 100}px`,
                                                            //height: `${10 + (pointCount / points.length) * 100}px`
                                                            width: `${zoom * 6
                                                                }px`,
                                                            height: `${zoom * 6
                                                                }px`
                                                        }}
                                                        onClick={() => {
                                                            const expansionZoom = Math.min(
                                                                supercluster.getClusterExpansionZoom(
                                                                    cluster.id
                                                                ),
                                                                20
                                                            );
                                                            mapRef.current.setZoom(
                                                                expansionZoom
                                                            );
                                                            mapRef.current.panTo(
                                                                {
                                                                    lat: latitude,
                                                                    lng: longitude
                                                                }
                                                            );
                                                        }}
                                                    >
                                                        <div className="span1">
                                                            <div className="span2">
                                                                <div className="text">
                                                                    {pointCount}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Marker>
                                            );
                                        }
                                        const isSelected =
                                            activeMarker !== undefined &&
                                            activeMarker.id ===
                                            cluster.properties.itemId;

                                        return (
                                            <Marker
                                                key={`item-${cluster.properties.itemId}`}
                                                lat={latitude}
                                                lng={longitude}
                                            >
                                                <div
                                                    data-id={
                                                        cluster.properties
                                                            .itemId
                                                    }
                                                    className={
                                                        isSelected
                                                            ? 'marker selected'
                                                            : 'marker'
                                                    }
                                                    data-lat={latitude}
                                                    data-lng={longitude}
                                                    onClick={() =>
                                                        handleSelected({
                                                            id:
                                                                cluster
                                                                    .properties
                                                                    .itemId,
                                                            lat: latitude,
                                                            lng: longitude
                                                        })
                                                    }
                                                >
                                                    <svg
                                                        style={{
                                                            maxWidth: `${zoom * 5
                                                                }px`,
                                                            maxHeight: `${zoom * 5
                                                                }px`
                                                        }}
                                                        alt={
                                                            'Marker_' +
                                                            cluster.id
                                                        }
                                                        className={cluster.properties.subsdiaryType === 'CP' ? 'marker-icon bankCode-cp' : cluster.properties.bankCode === '5387' ? 'marker-icon bankCode-05387' : 'marker-icon bankCode-03084'}
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="36"
                                                        height="48"
                                                        viewBox="0 0 36 48"
                                                    >
                                                        <path
                                                            id="icn-pointer"
                                                            d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
                                                            transform="translate(36 0)"
                                                            fill="#006369"
                                                        />
                                                    </svg>
                                                </div>
                                            </Marker>
                                        );
                                    })}
                                {/*
                                <Marker
                                    key="noh"
                                    lat={mapCenter.lat}
                                    lng={mapCenter.lng}
                                >
                                    <div>
                                        <svg
                                            style={{
                                                color: 'red',
                                                fill: 'red',
                                                maxWidth: `${zoom * 5}px`,
                                                maxHeight: `${zoom * 5}px`
                                            }}
                                            className="marker-icon"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="36"
                                            height="48"
                                            viewBox="0 0 36 48"
                                        >
                                            <path
                                                style={{
                                                    color: 'red',
                                                    fill: 'red'
                                                }}
                                                id="icn-pointer"
                                                d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
                                                transform="translate(36 0)"
                                                fill="#006369"
                                            />
                                        </svg>
                                    </div>
                                </Marker>*/
                                }


                                {
                                    /*
                                    locations && locations.map(el=>
                                        <Marker
                                        key="boooo"
                                        lat={el.latitude}
                                        lng={el.longitude}
                                    >
                                        <div>
                                            <svg
                                                style={{
                                                    color: 'red',
                                                    fill: 'red',
                                                    maxWidth: `${zoom * 5}px`,
                                                    maxHeight: `${zoom * 5}px`
                                                }}
                                                className="marker-icon"
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="36"
                                                height="48"
                                                viewBox="0 0 36 48"
                                            >
                                                <path
                                                    style={{
                                                        color: 'red',
                                                        fill: 'red'
                                                    }}
                                                    id="icn-pointer"
                                                    d="M-18,48c1.714,0,6.15-4.846,10.32-11.272a68.073,68.073,0,0,0,5.363-9.846A23.751,23.751,0,0,0,0,18,17.882,17.882,0,0,0-5.272,5.272,17.882,17.882,0,0,0-18,0,17.882,17.882,0,0,0-30.728,5.272,17.882,17.882,0,0,0-36,18a23.751,23.751,0,0,0,2.318,8.881,68.073,68.073,0,0,0,5.363,9.846C-24.15,43.154-19.714,48-18,48Zm0-36a6.007,6.007,0,0,1,6,6,6.007,6.007,0,0,1-6,6,6.007,6.007,0,0,1-6-6A6.007,6.007,0,0,1-18,12Z"
                                                    transform="translate(36 0)"
                                                    fill="#006369"
                                                />
                                            </svg>
                                        </div>
                                    </Marker>)
                                    */
                                }

                            </GoogleMapReact>
                        </div>
                    </div>
                </>
            ) : (
                    <></>
                )}
        </>
    );
}

export default MapWrapper;
